module.exports = __webpack_public_path__ + "static/media/cross-small.bf278d68.png";